import React, { useCallback } from 'react'

import EmptyMessage from 'components/App/DesktopView/Layout/RightSidebar/InAppCards/shared/EmptyMessage'
import NavigatableIntegrationWidgetCard from 'components/integrations/NavigatableIntegrationWidgetCard'
import { toTimePeriod } from 'util/date'
import { getFormattedPrice } from 'util/numbers'

export default function StripeSubscriptionRow({
  doNavigatableSetState,
  subscription,
}) {
  const { id, plan } = subscription || {}
  const {
    amount,
    currency,
    interval,
    interval_count: intervalCount,
    product: { name: productName } = {},
    nickname: planName,
  } =
    plan || {}
  const onClick = useCallback(
    () => {
      doNavigatableSetState({ id, type: 'subscription' })
    },
    [doNavigatableSetState, id]
  )
  if (!plan) return <EmptyMessage>No plan found on subscription</EmptyMessage>
  if (subscription) {
    return (
      <NavigatableIntegrationWidgetCard.ListItem
        onClick={onClick}
        subTitle={`${getFormattedPrice(amount, currency)} ${toTimePeriod(
          interval,
          intervalCount
        )}`}
        title={planName || productName}
      />
    )
  }
  return null
}
